export const PACKAGE_VALIDATION_CODES = {
  INVALID_ORIGIN: 'INVALID_ORIGIN',
  INVALID_DESTINATION: 'INVALID_DESTINATION',
  SAME_ORIGIN_DESTINATION: 'SAME_ORIGIN_DESTINATION',
  INVALID_DATES: 'INVALID_DATES',
  INVALID_PASSENGERS: 'INVALID_PASSENGERS',
};

export function normalizePackagePlaceIdValue(id) {
  if (id == null || id === '') return '';
  if (Array.isArray(id)) {
    return id
      .map((x) => String(x).trim())
      .filter(Boolean)
      .sort()
      .join(',');
  }
  const s = String(id).trim();
  if (s.includes(',')) {
    return s
      .split(',')
      .map((x) => x.trim())
      .filter(Boolean)
      .sort()
      .join(',');
  }
  return s;
}

export function packageOriginsAndDestinationsAreSame(origin, destination) {
  if (!origin || !destination) return false;
  const o = normalizePackagePlaceIdValue(origin.id);
  const d = normalizePackagePlaceIdValue(destination.id);
  return Boolean(o && d && o === d);
}

export function validatePackagesSearchFromForm(input) {
  if (!input?.origin) {
    return { code: PACKAGE_VALIDATION_CODES.INVALID_ORIGIN, message: 'Por favor seleccione un origen' };
  }
  if (!String(input.origin.name || '').trim()) {
    return { code: PACKAGE_VALIDATION_CODES.INVALID_ORIGIN, message: 'Por favor seleccione un origen' };
  }
  if (!normalizePackagePlaceIdValue(input.origin.id)) {
    return { code: PACKAGE_VALIDATION_CODES.INVALID_ORIGIN, message: 'Por favor seleccione un origen' };
  }
  if (!input?.destination) {
    return { code: PACKAGE_VALIDATION_CODES.INVALID_DESTINATION, message: 'Por favor seleccione un destino' };
  }
  if (!String(input.destination.name || '').trim()) {
    return { code: PACKAGE_VALIDATION_CODES.INVALID_DESTINATION, message: 'Por favor seleccione un destino' };
  }
  if (!normalizePackagePlaceIdValue(input.destination.id)) {
    return { code: PACKAGE_VALIDATION_CODES.INVALID_DESTINATION, message: 'Por favor seleccione un destino' };
  }
  if (packageOriginsAndDestinationsAreSame(input.origin, input.destination)) {
    return { code: PACKAGE_VALIDATION_CODES.SAME_ORIGIN_DESTINATION, message: 'No podés realizar una búsqueda con el mismo origen y destino.' };
  }
  if (!input.selectedMonth || !input.selectedYear) {
    return { code: PACKAGE_VALIDATION_CODES.INVALID_DATES, message: 'Por favor seleccione las fechas' };
  }
  if (!input.adultsQty || input.adultsQty < 1) {
    return { code: PACKAGE_VALIDATION_CODES.INVALID_PASSENGERS, message: 'Por favor seleccione la cantidad de pasajeros' };
  }
  return null;
}

const PACKAGE_FIELD_LABELS = {
  ORIGIN: 'origen',
  DESTINATION: 'destino',
  DATES: 'fechas',
  TURISTAS: 'turistas',
};

/**
 * Returns an array of Spanish field labels for required fields that are
 * missing or invalid in the given package search form input.
 *
 * The check mirrors `validatePackagesSearchFromForm` logic so labels
 * only appear for fields the validator would reject.
 *
 * @param {object|null} input
 * @returns {string[]}
 */
export function getMissingPackageFieldLabels(input) {
  const labels = [];
  if (
    !input?.origin ||
    !String(input.origin.name || '').trim() ||
    !normalizePackagePlaceIdValue(input.origin.id)
  ) {
    labels.push(PACKAGE_FIELD_LABELS.ORIGIN);
  }
  if (
    !input?.destination ||
    !String(input.destination.name || '').trim() ||
    !normalizePackagePlaceIdValue(input.destination.id)
  ) {
    labels.push(PACKAGE_FIELD_LABELS.DESTINATION);
  }
  if (!input?.selectedMonth || !input?.selectedYear) {
    labels.push(PACKAGE_FIELD_LABELS.DATES);
  }
  if (!input?.adultsQty || input.adultsQty < 1) {
    labels.push(PACKAGE_FIELD_LABELS.TURISTAS);
  }
  return labels;
}

export function validatePackagesSearchFromUrlParams({
  originId,
  originName,
  destinationId,
  destinationName,
  monthYear,
  adultsQty,
}) {
  const oId = normalizePackagePlaceIdValue(originId);
  const dId = normalizePackagePlaceIdValue(destinationId);
  const oName = originName != null ? String(originName).trim() : '';
  const dName = destinationName != null ? String(destinationName).trim() : '';
  if (!oId || !oName) {
    return { code: PACKAGE_VALIDATION_CODES.INVALID_ORIGIN, message: 'Por favor seleccione un origen' };
  }
  if (!dId || !dName) {
    return { code: PACKAGE_VALIDATION_CODES.INVALID_DESTINATION, message: 'Por favor seleccione un destino' };
  }
  if (oId === dId) {
    return { code: PACKAGE_VALIDATION_CODES.SAME_ORIGIN_DESTINATION, message: 'No podés realizar una búsqueda con el mismo origen y destino.' };
  }
  if (!monthYear || !String(monthYear).trim()) {
    return { code: PACKAGE_VALIDATION_CODES.INVALID_DATES, message: 'Por favor seleccione las fechas' };
  }
  const adultsRaw =
    adultsQty != null && String(adultsQty).trim() !== '' ? String(adultsQty).trim() : '1';
  const adults = Number(adultsRaw);
  if (!Number.isFinite(adults) || adults < 1) {
    return { code: PACKAGE_VALIDATION_CODES.INVALID_PASSENGERS, message: 'Por favor seleccione la cantidad de pasajeros' };
  }
  return null;
}
